import React, { Fragment, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { FaTrashAlt } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import { moment } from "utils"
import { deleteHeldOrder } from "@redux"
import HeldOrderItems from "./HeldOrderItems"
import { deliveryTypeLabels } from "constant"
import { ConfirmationModal, IconButton, Tooltip } from "components"
import HeldOrderCombos from "./HeldOrderCombos"
import HeldOrderTableRowRetrieveButton from "./HeldOrderTableRowRetrieveButton"
import classes from "./HeldOrderTableRow.module.scss"

const HeldOrderTableRow = props => {
  const { heldOrder, setOpenRetrievModal } = props

  const [t] = useTranslation()

  const dispatch = useDispatch()

  const serviceTypeName =
    useSelector(state =>
      state.systemSettings.serviceTypeName
    )

  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)

  const handleDeleteHeldOrder = () => {
    dispatch(
      deleteHeldOrder(heldOrder._id)
    )
  }

  const heldOrderDeliveryType =
    heldOrder.deliveryType === "dineIn" &&
      serviceTypeName === "shop"
      ? "selfPickup"
      : heldOrder.deliveryType

  return (
    <Fragment>
      <tr className={classes["item"]}>
        <td className={classes["text"]}>
          <div>
            {moment(heldOrder.date).format("jYYYY/jMM/jDD")}
          </div>
          <div>
            {moment(heldOrder.date).format("HH:mm")}
          </div>
        </td>
        <td className={classes["text"]}>
          <div>
            <HeldOrderItems
              heldOrder={heldOrder}
            />
            <HeldOrderCombos
              heldOrder={heldOrder}
            />
          </div>
        </td>
        <td className={classes["text"]}>
          {t(deliveryTypeLabels[heldOrderDeliveryType])}
        </td>
        {
          serviceTypeName === "restaurant" &&
          <td className={classes["text"]}>
            {heldOrder.tableNumber}
          </td>
        }
        <td className={classes["text"]}>
          <div className={classes["row"]}>

            <HeldOrderTableRowRetrieveButton
              heldOrder={heldOrder}
              setOpenRetrievModal={setOpenRetrievModal}
            />

            <Tooltip title={t("حذف_سفارش")}>
              <span>
                <IconButton
                  icon={FaTrashAlt}
                  size={22}
                  color="var(--color-danger)"
                  onClick={() => setOpenConfirmationModal(true)}
                />
              </span>
            </Tooltip>
          </div>
        </td>
      </tr>
      <ConfirmationModal
        title={t("آیا_می_خواهید_این_سفارش_را_حذف_کنید")}
        show={openConfirmationModal}
        onConfirm={handleDeleteHeldOrder}
        onHide={() => setOpenConfirmationModal(false)}
      />
    </Fragment>
  )
}

export default HeldOrderTableRow